export const AS_OF = "October 2026";

export const NAV_LINKS = [
  { id: "product", label: "Product" },
  { id: "traction", label: "Traction" },
  { id: "funds", label: "Use of Funds" },
  { id: "pricing", label: "Pricing" },
  { id: "milestones", label: "Milestones" },
  { id: "founder", label: "Founder" },
  { id: "materials", label: "Materials" },
  { id: "contact", label: "Contact" },
];

export const CONTACT = {
  name: "Sean Rawlins",
  role: "Founder & CEO",
  email: "info@wsafeai.com",
  site: "https://wsafe.ai/",
  product: "https://worksafeagent.com/",
};

export const OCT_DECK = {
  title: "WorkSafeAgent Investor Deck — October 2026",
  meta: "PDF · Investor deck",
  href: "/materials/WorkSafeAgent-Investor-Deck-Oct2026.pdf",
  action: "Download the October 2026 deck",
  testid: "download-october-deck",
};

export const ONE_PAGER = {
  title: "One-Pager (October 2026)",
  meta: "PDF · 1 page · Memo",
  href: "/materials/WorkSafeAgent-One-Pager-Oct2026.pdf",
  action: "Download",
  testid: "download-one-pager",
};

export const MODULES = [
  {
    name: "WSafe AI",
    tag: "AI Hazard Detection",
    desc: "AI hazard detection on existing CCTV, phone and body cameras.",
    icon: "Cpu",
  },
  {
    name: "InductIQ",
    tag: "Induction & Incident Management",
    desc: "Induction and training verification plus incident reporting, AI triage, paging and OSHA 300/300A logs.",
    icon: "UserCheck",
  },
  {
    name: "WorkSafeStory",
    tag: "Worker Safety Stories",
    desc: "Worker safety stories, Safety Tokens and incident narratives.",
    icon: "FileText",
  },
  {
    name: "SafeForm",
    tag: "Ergonomic Analysis",
    desc: "AI ergonomic analysis of worker posture and lifting.",
    icon: "PersonStanding",
  },
  {
    name: "HazardLoop",
    tag: "Closed-Loop Remediation",
    desc: "Hazard capture, routing and closed-loop remediation.",
    icon: "RefreshCw",
  },
  {
    name: "WSafe mobile app",
    tag: "Safety in Your Pocket",
    desc: "The full platform in a mobile app — safety in your pocket.",
    icon: "Smartphone",
  },
];

export const ROBOTICS =
  "Robotics (in development): a hardware-agnostic app that rides on any robot, uses its video and sensing, and pauses or reroutes after a safety alert.";

export const PARTNERS = [
  "Axis TIPP member",
  "Genetec integration in development",
  "Procore integration coming soon",
];

export const PATENT_LINE =
  "Patent pending. US provisional application filed Feb 27, 2026; additional provisional filings in progress covering CCTV and robotics applications.";

export const RESEARCH_CLAIM =
  "Research published on Zenodo projects a 59.4% reduction in total annual safety-related costs for a 500-person employer, and a 59% drop in recordable injury rate (3.2 to 1.3 per 100 workers). Research projection, not customer results.";

export const TRACTION = [
  {
    label: "Status",
    value: "Pre-revenue",
    status: "STATED PLAINLY",
    tone: "zero",
    detail: "$0 revenue, no paying customers or paid pilots yet.",
    testid: "traction-status",
  },
  {
    label: "Built So Far",
    value: "Shipped & filed",
    status: "DONE",
    tone: "live",
    detail: "Live product sites, a camera demo on Axis hardware, patent pending, research published.",
    testid: "traction-built",
  },
  {
    label: "Next",
    value: "Founding pilots",
    status: "UP NEXT",
    tone: "active",
    detail: "Founding pilots on active jobsites.",
    testid: "traction-next",
  },
  {
    label: "Founding Offer",
    value: "$1,000 pilot",
    status: "ACTIVE",
    tone: "active",
    detail: "Founding pilot offer open to the first customers on active jobsites.",
    testid: "traction-founding-offer",
  },
  {
    label: "Partners",
    value: "Axis · Genetec · Procore",
    status: "IN MOTION",
    tone: "pending",
    detail: "Axis TIPP member. Genetec integration in development. Procore integration coming soon.",
    testid: "traction-partners",
  },
  {
    label: "Intellectual Property",
    value: "Patent pending",
    status: "FILED",
    tone: "live",
    detail: "US provisional application filed Feb 27, 2026; additional provisional filings in progress covering CCTV and robotics applications.",
    testid: "traction-patent",
  },
  {
    label: "Research",
    value: "Published on Zenodo",
    status: "PUBLIC",
    tone: "live",
    detail: "Research published on Zenodo projects a 59.4% reduction in total annual safety-related costs for a 500-person employer, and a 59% drop in recordable injury rate (3.2 to 1.3 per 100 workers). Research projection, not customer results.",
    testid: "traction-research",
  },
  {
    label: "Entity",
    value: "WorkSafeAgent LLC",
    status: "REGISTERED",
    tone: "live",
    detail: "Abilene, TX. Founder-managed.",
    testid: "traction-entity",
  },
];

export const FUNDS = [
  { label: "Runway / founder ops", amount: 100000, note: "Keeps the company building and selling full-time." },
  { label: "Patent / legal", amount: 40000, note: "Prosecute the provisional and close the round cleanly." },
  { label: "Product / infra", amount: 40000, note: "Ship the product suite to pilot grade." },
  { label: "GTM / pilots", amount: 40000, note: "Travel, installs, and founding pilot acquisition." },
  { label: "Contingency", amount: 30000, note: "Honest buffer for the things we cannot see yet." },
];

export const PRICING = [
  {
    name: "Core",
    monthly: "$1,500",
    period: "/ mo",
    install: "+ $5K install",
    target: "Single-site validation",
    features: ["WSafe AI hazard detection", "SafeForm ergonomic analysis", "Standard support"],
    testid: "pricing-core",
  },
  {
    name: "Pro",
    monthly: "$3,000",
    period: "/ mo",
    install: "+ $10K install",
    target: "Multi-hall data centers",
    features: ["Everything in Core", "HazardLoop closed-loop remediation", "WorkSafeStory incident narratives", "InductIQ induction verification"],
    popular: true,
    testid: "pricing-pro",
  },
  {
    name: "Vision",
    monthly: "$6,250",
    period: "/ mo",
    install: "+ $25K install",
    target: "Critical-infrastructure operators",
    features: ["Everything in Pro", "WSafe mobile app", "Multi-site camera support (Axis hardware)", "Priority support"],
    testid: "pricing-vision",
  },
];

export const MILESTONES = [
  { n: "01", title: "4–6 months of runway", desc: "The $250K bridge funds full-time execution without another raise in between." },
  { n: "02", title: "Founding pilots on active jobsites", desc: "Convert the $1,000 founding offer into paying deployments on active jobsites — the proof point for everything after." },
  { n: "03", title: "Advisory board seated", desc: "Formalize the advisors already in conversation behind the product." },
  { n: "04", title: "Then — and only then — a $4.5M round", desc: "Raised after traction, on evidence. It is not the current ask." },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/32845695/pexels-photo-32845695.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  datacenter: "https://images.pexels.com/photos/38217230/pexels-photo-38217230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  technician: "https://images.pexels.com/photos/37605911/pexels-photo-37605911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
